module.exports = __webpack_public_path__ + "images/ds-oth-bg-banner-side.webp";